var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 70 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5 54.3139C53.1169 56.3704 50.0255 57.6119 46.6475 57.6119C39.1102 57.6119 33 51.4308 33 43.806C33 36.1811 39.1102 30 46.6475 30C50.0255 30 53.1169 31.2415 55.5 33.2981C57.8831 31.2415 60.9745 30 64.3525 30C71.8898 30 78 36.1811 78 43.806C78 51.4308 71.8898 57.6119 64.3525 57.6119C60.9745 57.6119 57.8831 56.3704 55.5 54.3139Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5 54.3139C58.4344 51.7816 60.2951 48.0136 60.2951 43.806C60.2951 39.5983 58.4344 35.8303 55.5 33.2981C57.8831 31.2415 60.9745 30 64.3524 30C71.8898 30 78 36.1811 78 43.806C78 51.4308 71.8898 57.6119 64.3524 57.6119C60.9745 57.6119 57.8831 56.3704 55.5 54.3139Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5 33.2981C58.4344 35.8304 60.2951 39.5984 60.2951 43.806C60.2951 48.0136 58.4344 51.7816 55.5 54.3138C52.5657 51.7816 50.705 48.0136 50.705 43.806C50.705 39.5984 52.5657 35.8304 55.5 33.2981Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.aa5739a22ed56fae75e302c37715e602.svg";
export { ForwardRef as ReactComponent };